import { memo, useMemo } from 'react';

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react";

import Type from '../Custom/Type.jsx';

import isEqual from 'react-fast-compare';
import { EVENT_TYPE } from '@/const.js';
import showErrMessage from '@/utils/showErrMessage.js';

const TypeSelect = memo(
  ({
    value,
    onChange,
    icon,
  }: {
    value: string;
    onChange: (payload: string) => void;
    icon?: string;
  }) => {
    const eventType = useMemo(() => {
      return EVENT_TYPE.filter(
        (i) => !['搜索地点', '添加交通'].includes(i.label)
      ).map((i) => {
        if (i.label === '自定义活动') {
          return {
            ...i,
            label: '自定义',
          };
        }
        return i;
      });
    }, []);

    return (
      <Dropdown>
        <DropdownTrigger>
          <span className='inline-flex items-center origin-top-left'>
            <Type type={value} icon={icon} />

            <i className='ic-round md-keyboard_arrow_down text-gray-400 -ml-1' />
          </span>
        </DropdownTrigger>

        {/* @ts-ignore children */}
        <DropdownMenu
          variant='flat'
          selectedKeys={value ? [value] : undefined}
          onSelectionChange={(res: Set<string>) => {
            try {
              const curValue = [...res][0];

              if (curValue) onChange(curValue);
            } catch (err) {
              showErrMessage(err);
            }
          }}
          selectionMode='single'
        >
          {eventType.map((i) => (
            <DropdownItem
              key={i.value}
              startContent={<i className={`ic-outline ${i.icon}`} />}
              style={{ color: i.color }}
              classNames={{ title: 'font-bold' }}
            >
              {i.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  },
  isEqual
);

export default TypeSelect;
